<template>
   <div>
      <fieldset class="border p-2 marb-12">
         <div class="form-group">
            <div class="row">
               <div class="col">
                  <field-col name="startDate" label="Start Date:" v-model="startDate" :v$="v$.startDate" lcols="1" icols="8" :typ="'date'" labelClassOverride="'label-auto-width'"></field-col>
               </div>
               <div class="col">
                  <field-col name="endDate" label="End Date:" v-model="endDate" :v$="v$.endDate" lcols="1" icols="8" :typ="'date'" labelClassOverride="'label-auto-width'"></field-col>
               </div>
            </div>
         </div>

         <div class="row">
            <div class="form-group col-6">
               <label>Recruiter Name:</label>
               <input type="text" class="form-control" placeholder="(200 chars max)" v-model="recruiterName" />
            </div>
            <div class="form-group col-6">
               <label>Level:</label>
               <input type="number" class="form-control" :placeholder="'(1-' + maxLIFE + ')'" v-model="levelNumber"
                  onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
                  maxlength="2" />
            </div>
         </div>
         <div class="row">
            <div class="form-group col-6">
               <label>Contract Status:</label>
               <select class="form-control" v-model="appointmentStatusId">
                  <option value="null">ALL STATUSES</option>
                  <option value="8">Approved</option>
                  <option value="7">Awaiting Approval</option>
                  <option value="6">Incomplete</option>
                  <option value="53">Abandoned</option>
               </select>
            </div>
         </div>
      </fieldset>
      
      <div class="instructions">* All Filters Optional. This report may take up to 20 minutes to run.</div>

      <div class="row mart-24">
         <div class="form-group col-6">
            <button type="button" :disabled="this.v$.$invalid" class="btn btn-lg ml-bk-purple ml-white ml-h-black marr-12" @click.prevent="handleSubmit">
               <template v-if="busy">
                  <i class="fas fa-spinner fa-spin ml-orange"></i>
               </template>
               <template v-if="this.v$.$invalid">
                  <i class="fas fa-exclamation"></i>
                  Correct errors to Submit
               </template>
               <template v-else>
                  <i class="fas fa-check"></i>
                  SUBMIT the Report REQUEST
               </template>
            </button>

            <button type="button" class="btn btn-lg ml-bk-black ml-white ml-h-orange" @click.prevent="handleClear">
               <template v-if="busy">
                  <i class="fas fa-spinner fa-spin ml-orange"></i>
               </template>
               <template v-else>
                  <i class="fas fa-times"></i>
                  CLEAR
               </template>
            </button>
         </div>
      </div>
   </div>
</template>

<script>
import moment from 'moment'
import FieldCol from '../fieldCol.vue';
import { useVuelidate } from '@vuelidate/core'
import { helpers } from '@vuelidate/validators'
import validationService from '../../validators/validatorService';

export default {
   props: ['userId', 'reportId'],
      components: {
      "field-col" : FieldCol
   },

   // Vuelidate Hooks, Setup and Validations
   setup() {
      return { v$: useVuelidate() }
   },
    validations() {
      return {
         startDate: { 
            isValidDate: helpers.withMessage('Start Date is invalid', validationService.isValidDate)
         },
         endDate: { 
            isValidDate: helpers.withMessage('End Date is invalid', validationService.isValidDate)
         }
      }
   },
   // End Vuelidate Hooks

   data() {
      return {
         startDate: null,
         endDate: null,
         recruiterName: '',
         appointmentStatusId: null,
         levelNumber: null,
         busy: false,
         maxLIFE: process.env.VUE_APP_MAX_LEVEL_PRODTYPE_LIFE
      }
   },

   methods: {
      handleClear() {
         this.startDate = null
         this.endDate = null
         this.recruiterName = ''
         this.appointmentStatusId = null
         this.levelNumber = 0
      },
      async handleSubmit() {
         this.$parent.$parent.loadingStart()
         this.busy = true
         let lvl = this.tryParseInt(this.levelNumber, null)
         let sId = this.tryParseInt(this.appointmentStatusId, null)

         let filter = {
            "userId": this.userId,
            "startDate": this.startDate,
            "endDate": this.endDate,
            "recruiterName": this.recruiterName,
            "appointmentStatusId": sId,
            "levelNumber": lvl
         }
         let payload = {
            requestDt: new Date(),
            requestedById: this.userId,
            reportId: this.reportId,
            inputJson: JSON.stringify(filter),
            filterText: this.filterText(JSON.stringify(filter))
         }

         await this.$reports.saveRequest(payload)
            .then(item => {
               this.handleClear()
               this.$emit("rpt-submitted");
               this.$parent.$parent.loadingEnd()
               this.busy = false

               this.$swal(
                  "Success!",
                  "Your report request was successfully queued up.",
                  "success"
               )
            })
            .catch(err => {
               this.$parent.$parent.loadingEnd()
               this.busy = false

               this.$swal(
                  "Oops!",
                  "An error occured on loading the page. Please try again later or contact support if the problem persists.",
                  "error"
               )
            })
      },
      filterText(inp) {
         let f = JSON.parse(inp)
         let o = ''
         if (f.startDate != null && f.startDate != '')
            o = o + 'Starting ' + moment(String(f.startDate), moment.ISO_8601).format('MM/DD/YYYY') + ', '
         if (f.endDate != null && f.endDate != '')
            o = o + 'Ending ' + moment(String(f.endDate), moment.ISO_8601).format('MM/DD/YYYY') + ', '
         if (f.recruiterName != null && f.recruiterName != '')
            o = o + `Recruiter Name contains "${f.recruiterName}", `
         if (f.appointmentStatusId != null && f.appointmentStatusId != 0) {
            switch (f.appointmentStatusId) {
               case 6:
                  o = o + 'Incomplete Appointments, '
                  break
               case 7:
                  o = o + 'Appointments Pending Approval, '
                  break
               case 8:
                  o = o + 'Approved Appointments, '
                  break
               case 53:
                  o = o + 'Abandoned Appointments, '
                  break
               default:
                  o = o + 'All Appointment Satuses, '
            }
         }
         if (f.levelNumber != null && f.levelNumber != 0) {
            o = o + `Level ${f.levelNumber}, `
         }
         if (o.trim() == '') return '(none)'
         return o.substr(0, o.length - 2)
      },
      tryParseInt(str, defaultValue) {
         var retValue = defaultValue;
         if (str !== null) {
            if (str.length > 0) {
               if (!isNaN(str)) {
                  retValue = parseInt(str);
               }
            }
         }
         return retValue;
      },
   }
}
</script>

<style scoped lang="scss">
@import '../../assets/css/colors.scss';
</style>